import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Tab, Tabs } from '@node-space/ui-components'
import { usePaymentCaseContext } from 'hooks/context/usePaymentCaseContext'
import { CaseDetailsTabs } from 'types/payments'
import { PaymentCaseDocumentsBody } from './PaymentCaseDocumentsBody'
import { PaymentCaseEmailsBody } from './PaymentCaseEmailsBody'

export const PaymentCaseDetailsBody = () => {
  const { t } = useTranslation()

  const { paymentCaseId } = usePaymentCaseContext()

  const paymentCaseDetailsTabs: Tab[] = [
    {
      id: CaseDetailsTabs.EMAILS,
      content: <PaymentCaseEmailsBody />,
      header: t('paymentSupport.emails'),
      testId: 'payment-case-emails-tab',
    },
    {
      id: CaseDetailsTabs.DOCUMENTS,
      content: <PaymentCaseDocumentsBody />,
      header: t('paymentSupport.documents'),
      testId: 'payment-case-docs-tab',
    },
  ]

  return (
    <Box id="caseDetailsBody" height="full" width="full" className="relative">
      {paymentCaseId && <Tabs tabs={paymentCaseDetailsTabs} />}
    </Box>
  )
}
